import * as z from "zod/v4";

export const deleteProductFilter = {
  name: "deleteProductFilter" as const,
  input: z.object({ id: z.string() }),
  output: z.object({ success: z.boolean() }),
};
